import { Chip } from '@sortlist-frontend/design-system';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { formatNumber } from '@sortlist-frontend/utils';
import { Fragment } from 'react';

import { rankingConfig } from '../ranking.config';

interface ListingPagesNavProps {
  totalAgenciesCount: number;
  pages: readonly number[];
  serviceName: string;
  path: string;
  locale: string;
}

export const ListingPagesNav = (props: ListingPagesNavProps) => {
  const { totalAgenciesCount, pages, serviceName, path, locale } = props;
  const { t } = useTranslation(rankingConfig.i18nNamespaces);

  return (
    <nav
      aria-label={t('longtail:ranking.listing.label')}
      className="mt-8 flex flex-wrap items-center gap-3 text-sm text-secondary-500">
      <span>
        {t('longtail:ranking.listing.browseAll', {
          total: formatNumber({ value: totalAgenciesCount, locale }),
          service: serviceName,
        })}
      </span>
      {pages.map((page, index) => {
        const previousPage = pages[index - 1];
        const hasGap = previousPage != null && page - previousPage > 1;

        return (
          <Fragment key={page}>
            {hasGap ? <span aria-hidden="true">…</span> : null}
            <Chip as="a" href={`${path}?page=${page}`} color="primary" variant="bordered" radius="full" size="md">
              {t('longtail:pagination.pageLabel', { page })}
            </Chip>
          </Fragment>
        );
      })}
    </nav>
  );
};
